import { useNavigate } from 'react-router-dom';

import { IStorePackage } from 'models/store/i-store-package.interface';

import { PROFILE_ROUTES } from 'constants/routes.constant';

import { getEtherscanUrl } from 'services/network.service';

import { PackageImage } from 'components/packageImage/PackageImage';

import { centralEllipsis } from 'utils/ellipsis.utils';

import ButtonDefault from '../../../buttons/ButtonDefault';
import ButtonRegular from '../../../buttons/ButtonRegular';
import './PackageCheckoutModalSuccess.scss';

type PackageCheckoutModalSuccessProps = {
  transactionHash: string;
  packageDetails: IStorePackage;
  onClickClose: () => void;
};

const PackageCheckoutModalSuccess = ({
  transactionHash,
  packageDetails,
  onClickClose,
}: PackageCheckoutModalSuccessProps) => {
  const navigate = useNavigate();

  const onClickViewItems = () => {
    navigate(`${PROFILE_ROUTES.COLLECTED}`);
  };

  return (
    <div className="checkout-modal-success">
      <div className="checkout-modal-success__venue-container">
        <PackageImage
          src={packageDetails.image_url}
          alt={packageDetails.name}
          totalShares={packageDetails.total_shares}
          wrapperClassName="tw-max-w-[243px]"
          countClassName="tw-text-[29px] tw-leading-[28.6px]"
          countSubtitleClassName="tw-text-[12px] tw-font-semibold"
        />
      </div>
      <div className="checkout-modal-success__details">
        <p className="checkout-modal-success__details-section">
          Your purchased of <b>{packageDetails.name}</b>.<br />
          It should be confirmed on the blockchain shortly.
        </p>
        <div className="checkout-modal-success__details-section">
          <p>Transaction ID:</p>
          <a
            target="_blank"
            rel="noreferrer"
            className="checkout-modal-success__hash-link"
            href={getEtherscanUrl(transactionHash)}
          >
            {centralEllipsis(transactionHash)}
          </a>
        </div>
      </div>
      <div className="checkout-modal-success__footer">
        <ButtonDefault type="button" text="CLOSE" onClick={onClickClose} />
        <ButtonRegular type="button" text="VIEW ITEMS" onClick={onClickViewItems} />
      </div>
    </div>
  );
};

export default PackageCheckoutModalSuccess;
